import styled from '@emotion/styled'
import * as Profile from '@util/profile'
import * as Style from '@util/style'
import { ISceneProps } from '@util/types'
import {
  ButtonDefault,
  ButtonPrimary,
  Logo,
  mediaBreakpointUp,
  useTrackViewAnonymous
} from '@util/ui'
import plate from './grilled-chicken.png'

const WelcomeScene: React.FC<ISceneProps> = ({ navigator }) => {
  useTrackViewAnonymous('my_web:viewed_welcome')

  const handleContinue = () => {
    navigator.go(import('../menu'), { initialProfile: Profile.makeEmpty() })
  }

  const handleSignIn = () => {
    navigator.go(import('../sign-in'), {})
  }

  return (
    <Grid>
      <Message>
        <Logo
          width="10rem"
          style={{ color: Style.COLOR.GREY_800, flexShrink: 0 }}
        />

        <Wrapper>
          <Tagline>Meal planning made easy.</Tagline>
          <Art src={plate} alt="Plate of food" />
        </Wrapper>
      </Message>
      <Actions>
        <div style={{ alignSelf: 'center' }}>
          <ButtonPrimary
            shadow
            large
            type="button"
            onClick={handleContinue}
            style={{
              width: '100%',
              marginTop: '1rem',
              marginBottom: '1rem'
            }}
          >
            Get Started
          </ButtonPrimary>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: Style.COLOR.GREY_700,
              backgroundColor: Style.COLOR.GREY_100,
              paddingLeft: '1.5rem',
              borderRadius: '0.5rem'
            }}
          >
            Already have an account?
            <ButtonDefault
              type="button"
              onClick={handleSignIn}
              style={{ marginLeft: '1rem' }}
            >
              Sign in
            </ButtonDefault>
          </div>
        </div>
      </Actions>
    </Grid>
  )
}

const Grid = styled.div({
  display: 'grid',
  height: '100%',
  minHeight: 530, // Stop components from collapsing on each other.
  overflow: 'hidden',
  gridTemplateRows: '4fr 1fr',

  [mediaBreakpointUp('md')]: {
    gridTemplateRows: 'none',
    gridTemplateColumns: '1fr 1fr'
  }
})

const Message = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: Style.COLOR.GREY_100,
  paddingTop: '2rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  overflow: 'hidden',

  [mediaBreakpointUp('sm')]: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem'
  },

  [mediaBreakpointUp('md')]: {
    paddingLeft: '3rem',
    paddingRight: '3rem'
  }
})

const Actions = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  paddingBottom: '2rem',
  backgroundColor: 'white',

  [mediaBreakpointUp('md')]: {
    position: 'relative'
  }
})

const Wrapper = styled.div({
  flex: 1,
  display: 'grid',
  placeItems: 'center'
})

const Tagline = styled.h2({
  maxWidth: '12ch',
  fontSize: '3.5rem',
  color: Style.COLOR.GREY_800,
  lineHeight: 1,
  letterSpacing: -1,
  marginTop: 'auto',
  marginBottom: 'auto',
  paddingBottom: '40%',
  justifySelf: 'center',

  [mediaBreakpointUp('md')]: {
    fontSize: '3.5rem',
    paddingBottom: '40%'
  },

  [mediaBreakpointUp('lg')]: {
    fontSize: '4.5rem',
    paddingBottom: '62%'
  },

  [mediaBreakpointUp('xl')]: {
    fontSize: '4.5rem',
    paddingBottom: '30%'
  }
})

const Art = styled.img({
  position: 'absolute',
  width: '175%',
  top: '50%', // hide a little less than half the image.
  left: '50%',
  transform: 'translateX(-50%)',

  [mediaBreakpointUp('md')]: {
    width: '150%',
    top: '60%'
  },

  [mediaBreakpointUp('lg')]: {
    width: '175%',
    maxWidth: 1000,
    top: '50%'
  }
})

export default WelcomeScene
